import React from "react";
import { motion } from "framer-motion";
import "../../assets/css/servicespage.css";

export default function Services() {
  const isMobile = window.innerWidth < 768;
    const domestic = ["Goa", "Daman", "Kerala", "Sikkim", "Ujjain", "Rajasthan"];
  const international = ["Thailand", "Vietnam", "Dubai", "Malaysia", "Cambodia"];

  return (
    <>
 <div className="services">

      {/* Background Blobs */}
      <div className="blob blob1"></div>
      <div className="blob blob2"></div>
      <div className="blob blob3"></div>

      <div className="wrapper">

        {/* Domestic Section */}
        <div className="card">
          <h2 className="title">🇮🇳 Domestic Tours</h2>

          <div className="list">
            {domestic.map((place, i) => (
              <div key={i} className="item">
                <span className="dot"></span>
                {place}
              </div>
            ))}
          </div>
        </div>

        {/* International Section */}
        <div className="card">
          <h2 className="title">🌍 International Tours</h2>

          <div className="list">
            {international.map((place, i) => (
              <div key={i} className="item">
                <span className="dot"></span>
                {place}
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
        <section className="offersWrap">

      <motion.div
        className="offersCard"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >

        {/* LEFT SIDE */}
        <div className="offersLeft">

          <motion.div
            className="line"
            initial={{ height: 0 }}
            whileInView={{ height: "100%" }}
            transition={{ duration: 0.4 }}
          />

          <div>
            <h1>SPECIAL OFFERS & PACKAGES</h1>

            <h3>Exclusive Deals by Trip Word</h3>

            <p>
              Grab the best travel experiences at unbeatable prices! <br />
              We bring you specially curated travel packages for groups, families, and corporate trips with complete arrangements — travel, stay, and experiences included.
            </p>
          </div>

        </div>

        {/* RIGHT SIDE VISUAL */}
     <div className="offersRight">

  <motion.div
    className="floatingBox box1"
    animate={isMobile ? {} : { y: [0, -10, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
  >
    Travel
  </motion.div>

  <motion.div
    className="floatingBox box2"
    animate={isMobile ? {} : { y: [0, 15, 0] }}
    transition={{ repeat: Infinity, duration: 4 }}
  >
    Deals
  </motion.div>

  <motion.div
    className="floatingBox box3"
    animate={isMobile ? {} : { y: [0, -3, 0] }}
    transition={{ repeat: Infinity, duration: 6 }}
  >
    Luxury
  </motion.div>

</div>

      </motion.div>

    </section>
    </>
  );
}